<template>
  <div class="footer pr">
    <div class="pa">
      <p>Copyright©  2018-2025 浙江固德有限公司 版权所有 保留一切权利</p>
      <p>
        浙ICP备18011813号-1 | <a
          href="http://www.goodyiyao.com/images/certificate/1741250922456.jpg"
          target="_blank"
        >药品经营许可证 </a>|<a
          href="http://www.goodyiyao.com/images/certificate/互联网信息服务资格证书正本.png"
          target="_blank"
        > 互联网药品信息服务资格证书 </a>| <a
          href="http://www.goodyiyao.com/images/certificate/营业执照.jpg"
          target="_blank"
        >企业法人营业执照 </a>|<a
          href="http://www.goodyiyao.com/images/certificate/医疗器械经营许可证2023.10.17.jpg"
          target="_blank"
        > 医疗器械经营许可证</a>
      </p>
      <p>
        <!-- <a
          href="http://www.goodyiyao.com/images/certificate/SecondClass.jpg"
          target="_blank"
        > 第二类医疗器械经营备案凭证 </a> -->
        <!--|<a href="http://www.goodyiyao.com/images/certificate/GSP.jpg" target="_blank"> GSP认证证书 </a>--><a
          target="_blank"
          class="split"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33032202000166"
        >浙公网安备 33032202000166号</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
    a{
        text-decoration: none;
        color: #323232
    }
    .footer{
        background: #eefded;
        max-width: 100%;
        height: 80px;
        color: #323232;
        text-indent: 15px;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        overflow: hidden;
    }

    .pa{
        display: flex;
        max-width: 100%;
        margin: 0 auto;
        flex-direction: column;
        justify-content: center;
    }
    .split{
        background: url('../assets/images/recode.png') 5px center no-repeat;
        padding-left: 2em;
    }
</style>

<script>
export default {
    methods: {
    }
}
</script>